import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { DirectoryHeader } from "./Directory/components/DirectoryHeader";
import { DirectoryFilters } from "./Directory/components/DirectoryFilters";
import { DirectoryContent } from "./Directory/components/DirectoryContent";
import { useDirectoryData } from "./Directory/hooks/useDirectoryData";
import { useDirectoryFilters } from "./Directory/hooks/useDirectoryFilters";
import { MobileNavigation } from "@/components/MobileNavigation";
import { PremiumRoute } from "@/components/PremiumRoute";

const Directory = () => {
  const { toast } = useToast();
  const {
    profiles,
    organizations,
    categories,
    loading,
    currentPage,
    totalPages,
    handlePageChange,
  } = useDirectoryData({ toast });

  const {
    searchTerm,
    selectedCategory,
    selectedDirectoryCategory,
    selectedLanguages,
    selectedExperienceLevel,
    selectedAvailability,
    filteredProfiles,
    filteredOrganizations,
    setSearchTerm,
    setSelectedCategory,
    setSelectedDirectoryCategory,
    setSelectedLanguages,
    setSelectedExperienceLevel,
    setSelectedAvailability,
    showOrganizations,
    setShowOrganizations
  } = useDirectoryFilters({ profiles, organizations });

  // Add new state for looking for categories and budget range
  const [selectedLookingFor, setSelectedLookingFor] = useState<string[]>([]);
  const [budgetRange, setBudgetRange] = useState<[number, number]>([0, 10000]);

  return (
    <PremiumRoute pageName="Directory">
      <div className="container mx-auto px-4 pt-20 sm:pt-24 pb-20 md:pb-8 min-h-screen">
        <DirectoryHeader />
        
        <DirectoryFilters
          categories={categories}
          selectedCategory={selectedCategory}
          searchTerm={searchTerm}
          showOrganizations={showOrganizations}
          onCategoryChange={setSelectedCategory}
          onSearchChange={setSearchTerm}
          onToggleView={() => setShowOrganizations(!showOrganizations)}
          selectedLookingFor={selectedLookingFor}
          onLookingForChange={setSelectedLookingFor}
          budgetRange={budgetRange}
          onBudgetRangeChange={setBudgetRange}
        />

        <DirectoryContent
          profiles={filteredProfiles}
          organizations={filteredOrganizations}
          loading={loading}
          showOrganizations={showOrganizations}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
      <MobileNavigation />
    </PremiumRoute>
  );
};

export default Directory;